import { render, staticRenderFns } from "./ResearcherClaimsHistory.vue?vue&type=template&id=7cf56260&"
import script from "./ResearcherClaimsHistory.vue?vue&type=script&lang=js&"
export * from "./ResearcherClaimsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports